exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-ai-intention-modal .ai-intention-header-icon{color:var(--fts-ai)}", ""]);

// exports
